export default __webpack_public_path__ + "static/media/image2.7adfdf90.png";